// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"a663b14b","702":"fea67066","744":"54a04eea","967":"907c32c7"}[chunkId] + ".chunk.js";
};